export const RESERVED_COPILOT_TURN_PREFIX = 'copilot-turn-'

/** Validate a client-owned turn id without interpreting ids received from the host. */
export function assertClientTurnId(turnId: string): string {
  if (turnId.length === 0) {
    throw new Error('client turn id must be non-empty')
  }
  if (turnId.startsWith(RESERVED_COPILOT_TURN_PREFIX)) {
    throw new Error(`client turn id must not use the reserved '${RESERVED_COPILOT_TURN_PREFIX}' prefix`)
  }
  return turnId
}

export function createClientTurnId(randomUUID: () => string = () => crypto.randomUUID()): string {
  return assertClientTurnId(randomUUID())
}
